import React from "react";
import Navbar from "../components/Navbar/Navbar";
import ViewScoreQuestionType from "../components/MT_Score/ViewScoreQuestionType";
import ScoreViewHeaderForTeacher from "../components/MT_Score/ScoreViewHeaderForTeacher";
import { useParams } from "react-router-dom";

const MtScoreViewScoreQuestionType = () => {
  const { userId } = useParams();
  return (
    <>
      {userId ? <ScoreViewHeaderForTeacher /> : <Navbar />}
      <ViewScoreQuestionType />
    </>
  );
};

export default MtScoreViewScoreQuestionType;
